import { boot } from 'quasar/wrappers'
import axios from 'axios'
import {useAuthStore} from 'src/stores/AuthStore.js'
import {isPasswordChangeRequiredError} from 'src/classes/PasswordChange.js'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
//const api = axios.create({ baseURL: 'https://api.example.com' })

export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  //app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API

  axios.defaults.baseURL = PP_CONST.HOST + '/i1-mobileproxy/service/rest'
  //axios.defaults.baseURL = PP_CONST.HOST + '/i1-mobileproxy-jwt/service/rest'
  //axios.defaults.headers.contentType = 'application/json;charset=UTF-8'
  axios.defaults.withCredentials = false
  axios.defaults.headers = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
    'Content-Type': 'application/json;charset=UTF-8'
  }

  // #900: the MobileProxy rejects business calls with HTTP 403 / iResult -720 while a password change is pending.
  // Switch to the mandatory password change view; the rejection itself is passed on unchanged.
  axios.interceptors.response.use(response => response, error => {
    if (isPasswordChangeRequiredError(error)) {
      try {
        useAuthStore().passwordChangeRequired = true
      } catch (e) {
        console.warn('passwordChangeRequired could not be set', e)
      }
    }
    return Promise.reject(error)
  })
})

// export { api }
